import { $ } from '../utils/Utils';

const Flickity = require('flickity');

const project = (() => {
  const config = {
    carousel: [...$('.js-projectCarousel')],
  };

  const handleCarousel = ($trigger) => {
    const gallery = new Flickity($trigger, {
      pageDots: false,
      prevNextButtons: false,
    });

    gallery.on('change', () => {
      // add aria hidden on all cells
      gallery.cells.forEach((cell) => {
        cell.element.setAttribute('aria-hidden', 'true');
      });
      // remove aria hidden on select cell
      gallery.selectedElement.removeAttribute('aria-hidden');
    });

    gallery.on('settle', () => {
      // get cell height
      const cHeight = gallery.selectedElement.offsetHeight;
      // get gallery height
      const gHeight = gallery.element.offsetHeight;
      // check if the cell is bigger than the gallery
      // (the gallery has a overflow hidden)
      // if so, resize to adjust the height
      if (cHeight > gHeight) {
        gallery.resize();
      }
    });
  };

  const build = () => {
    config.carousel.forEach($trigger => handleCarousel($trigger));
  };

  const init = () => {
    if (config.carousel.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

export default project.init();
